import { Link } from 'react-router'
import logoUrl from '#app/assets/favicons/favicon.svg'

/**
 * Shared shell for the public marketing subpages (privacy, voorwaarden,
 * support, over ons) — same glass header + dark surface as the landing
 * page, with a typographic content column.
 */
export function MarketingPage({
	title,
	intro,
	children,
}: {
	title: string
	intro?: string
	children: React.ReactNode
}) {
	return (
		<div className="min-h-screen bg-[#18181b] text-[#e4e4e7]">
			<header className="glass-header fixed top-0 z-50 flex h-16 w-full items-center justify-between px-6">
				<Link
					to="/"
					className="font-display flex items-center gap-2 text-[10px] text-neon-pink"
				>
					<img src={logoUrl} alt="" className="h-6 w-6" />
					MUZIEKDOCENT
				</Link>
				<div className="flex items-center gap-4">
					<Link
						to="/login"
						className="text-sm text-text-muted transition-colors duration-150 hover:text-white"
					>
						Inloggen
					</Link>
					<Link
						to="/signup"
						className="rounded-lg bg-violet-600 px-4 py-2 text-sm font-medium text-white shadow-[0_0_15px_rgba(139,92,246,0.3)] transition-colors duration-150 hover:bg-violet-500"
					>
						Gratis starten
					</Link>
				</div>
			</header>

			<main className="mx-auto max-w-2xl px-6 pt-32 pb-24">
				<h1 className="text-3xl font-bold text-white">{title}</h1>
				{intro ? (
					<p className="mt-4 text-sm leading-relaxed text-text-muted">
						{intro}
					</p>
				) : null}
				<div className="mt-10 space-y-10">{children}</div>
			</main>

			<footer className="border-t border-white/5 px-6 py-10 text-center">
				<Link to="/" className="text-xs text-text-dim hover:text-white">
					← Terug naar muziekdocent.nl
				</Link>
			</footer>
		</div>
	)
}

export function MarketingSection({
	id,
	title,
	children,
}: {
	id?: string
	title: string
	children: React.ReactNode
}) {
	return (
		<section id={id} className="scroll-mt-24">
			<h2 className="text-lg font-semibold text-white">{title}</h2>
			<div className="mt-3 space-y-3 text-sm leading-relaxed text-text-muted">
				{children}
			</div>
		</section>
	)
}
